const validParams = {
  desktopmenu: ['right', 'left'],
  mobileinfobutton: ['true', 'false'],
  mobilehelpbutton: ['true', 'false'],
  iosarbutton: ['true', 'false'],
  mobilefullscreenbutton: ['true', 'false'],
  autorotate: ['true', 'false'],
};

export default function validateParamsObject(obj) {
  const validObject = {};
  Object.entries(obj).map((item) => {
    if (validParams.hasOwnProperty(item[0])) {
      if (validParams[item[0]].includes(item[1])) {
        validObject[item[0]] = item[1];
      }
    }
  });
  return validObject;
}
